import {DiscordUrl, TwitterUrl, TelegramUrl, MediumUrl, RedditUrl, YoutubeUrl} from "../constants";
import classNames from "classnames";

import {ReactComponent as TelegramIcon} from '../assets/icons/social/telegram.svg';
import {ReactComponent as TwitterIcon} from '../assets/icons/social/twitter.svg';
import {ReactComponent as YoutubeIcon} from '../assets/icons/social/youtube.svg';
import {ReactComponent as DiscordIcon} from '../assets/icons/social/discord.svg';
import {ReactComponent as RedditIcon} from '../assets/icons/social/reddit.svg';
import {ReactComponent as MediumIcon} from '../assets/icons/social/medium.svg';

const SOCIAL_LINKS = [
    {label: 'Telegram', href: TelegramUrl, Icon: TelegramIcon},
    {label: 'X (Twitter)', href: TwitterUrl, Icon: TwitterIcon},
    {label: 'YouTube', href: YoutubeUrl, Icon: YoutubeIcon},
    {label: 'Discord', href: DiscordUrl, Icon: DiscordIcon},
    {label: 'Reddit', href: RedditUrl, Icon: RedditIcon},
    {label: 'Medium', href: MediumUrl, Icon: MediumIcon},
];

export const SocialIcons = ({className}) => {
    return (
        <div className={classNames(['SocialIcons', className])}>
            {SOCIAL_LINKS.map(({label, href, Icon}) => (
                <a key={label}
                   href={href}
                   target={'_blank'}
                   rel={'noreferrer'}
                   className={'SocialIcon'}
                   aria-label={label}
                >
                    <Icon aria-hidden={'true'} focusable={'false'}/>
                </a>
            ))}
        </div>
    );
};

export default SocialIcons;
